
const CustomerRoutes = [
  {
    path: '/ecommerce/coupons',
    name: 'coupons',
    component: () => import(/* webpackChunkName: "coupons" */ './Coupon.vue'),
    meta: {
      requiresAuth: true,
      breadCrumbs: [
        {
          name: 'All Coupon',
          path: '/ecommerce/coupons',
        },
      ],
    },
    children: [
      {
        path: '',
        name: 'coupons',
        component: () => import(/* webpackChunkName: "coupons" */ './components/Coupons'),
        meta: {
          breadCrumbs: [
            {
              name: 'All Coupon',
              path: '/ecommerce/coupons',
            },
          ],
        },
      },
      {
        path: 'items',
        name: 'coupons-items',
        component: () => import(/* webpackChunkName: "coupons-items" */ './components/CouponsItems'),
        meta: {
          breadCrumbs: [
            {
              name: 'All Coupon',
              path: '/ecommerce/coupons',
            },
            {
              name: 'Coupon Items',
              path: '#',
            },
          ],
        },
      },
    ],
  },
];

export default CustomerRoutes;
